import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { motion, AnimatePresence } from "framer-motion";

export default function About_firstpage() {
  const { t } = useTranslation();

  const [rippleStyle, setRippleStyle] = useState({});
  const [isAnimating, setIsAnimating] = useState(false);

  const handleMouseEnter = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    setRippleStyle({ top: y, left: x });
    setIsAnimating(true);
  };

  const handleClick = (e) => {
      const element = document.getElementById('team');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    handleMouseEnter(e);
  };

  const handleMouseLeave = () => {
    setIsAnimating(false);
  };

  return (
    <div className="w-full flex justify-center items-center py-8">
      <div className="w-full max-w-7xl relative">
        {/* Content Section */}
        <div className="flex flex-wrap px-4 mb-8 gap-y-8">
          {/* Left Section */}
          <div className="md:w-1/2 md:block">
            <h1 className="text-5xl mb-4 md:mb-8">
              {t("aboutPage.welcomeHeadingPart1")}
              <br />
              {t("aboutPage.welcomeHeadingPart2")}
            </h1>
            <motion.button
              className="px-6 py-3 bg-gray-900 text-white text-sm font-semibold rounded shadow flex gap-4 items-center group relative overflow-hidden"
              onMouseEnter={handleMouseEnter}
              onClick={handleClick}
              onMouseLeave={handleMouseLeave}
            >
              <span>{t("aboutPage.meetOurTeam")}</span>

              <svg
                className="transition-transform group-hover:translate-x-2 rtl:rotate-180 rtl:group-hover:-translate-x-2"
                width="8"
                height="14"
                viewBox="0 0 8 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 13.1831L7 7.18311L1 1.18311"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              {/* Ripple effect */}
              <AnimatePresence>
                {isAnimating && (
                  <motion.span
                    className="absolute w-4 h-4 rounded-full"
                    style={{
                      top: rippleStyle.top,
                      left: rippleStyle.left,
                      backgroundColor: "white",
                    }}
                    initial={{ scale: 0, opacity: 1 }}
                    animate={{ scale: 30, opacity: 0.5 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                  />
                )}
              </AnimatePresence>
            </motion.button>
          </div>

          {/* Right Section */}
          <div className="w-full md:w-1/2 flex flex-col gap-4">
            <p className="flex gap-2 items-center text-gray-700">
              <svg
                width="16"
                height="2"
                viewBox="0 0 16 2"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <line y1="0.683105" x2="16" y2="0.683105" stroke="#272727" />
              </svg>
              <span className="font-medium">{t("aboutPage.ourVision")}</span>
            </p>
            <p className="text-gray-600">{t("aboutPage.visionDescription")}</p>
          </div>
        </div>

        {/* Image Section */}
        <div className="p-4 md:p-10">
          <img
            src="assets/firstpageimage.webp"
            className="grayscale hover:grayscale-0 h-64 sm:h-80 md:h-[35rem] w-full object-cover rounded-lg"
            alt={t("aboutPage.altImageText")}
          />
        </div>

        {/* Background Section */}
        <div className="h-64 sm:h-80 md:h-[30rem] w-screen lg:w-full bg-blue-tint absolute bottom-0 left-0 right-0 -z-10"></div>
      </div>
    </div>
  );
}
